import React, { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { S3_PREFIX } from '@shared/constants'
import usePoll from '@shared/hooks/usePoll'
import { abbreviateNumber } from '@shared/utils'

const PollStyle = dynamic(() => import('@shared/components/multiPoll/pollStyle'))
const MyImage = dynamic(() => import('@shared/components/myImage'))
function SimplePoll({ poll, className }) {
  const { pollData, handleAnswer, isActive, getPercentage, message, isExpired, selectedOption } = usePoll({ poll })
  const { t } = useTranslation()
  const [render, setRender] = useState()

  useEffect(() => {
    setRender({ selectedOption })
  }, [selectedOption])
  return (
    <PollStyle>
      {(pollStyle) => (
        <section
          className={`${pollStyle.pollBg} py-3 ${className || ''} position-relative overflow-hidden br-sm`}
          style={{ backgroundImage: `url(${S3_PREFIX + pollData?.oBgImgUrl?.sUrl})` }}
        >
          <h3 className="small-head position-relative px-3 mb-2">{pollData?.sTitle}</h3>
          <div className="d-flex flex-wrap align-items-center position-relative">
            {pollData?.oMediaUrl?.sUrl && (
              <div className={`${styles.pollItem} px-3 flex-grow-1`}>
                <div className="br-sm overflow-hidden my-2 position-relative mb-2">
                  {pollData?.eMediaType === 'i' && (
                    <MyImage
                      src={S3_PREFIX + pollData?.oMediaUrl?.sUrl}
                      alt={pollData?.oMediaUrl?.sAttribute || pollData?.oMediaUrl?.sText}
                      height={200}
                      width={320}
                      className="mb-0"
                      sizes="(max-width: 768px) 80px, 320px"
                    />
                  )}
                  {pollData?.eMediaType === 'v' && (
                    <div className="ratio ratio-16x9">
                      <iframe
                        width="560"
                        height="315"
                        src={pollData?.oMediaUrl?.sUrl}
                        title={pollData?.oMediaUrl?.sAttribute || pollData?.oMediaUrl?.sText}
                        allow="autoplay"
                        loading="lazy"
                        className="pe-none"
                      />
                    </div>
                  )}
                  {/* For Iframe View */}
                  {/* <div className="ratio ratio-16x9">
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/AFEZzf9_EHk?si=LodYE6VjZJTuDeWx" title="YouTube video player" allow="autoplay"></iframe>
                  </div> */}
                </div>
              </div>
            )}
            <div className={`${styles.pollItem} px-3 flex-grow-1`}>
              <div className="text-center d-flex flex-wrap mx-n1 position-relative">
                {pollData?.aField?.map((o, i) => {
                  const p = getPercentage(o?.nVote)
                  return (
                    <div
                      key={o?._id}
                      className={`${styles.item} c-pointer p-2 position-relative overflow-hidden br-sm mb-2 flex-grow-1 mx-1`}
                      onClick={() => handleAnswer(o?._id)}
                    >
                      <div className={`${styles.option} py-1 position-relative d-flex justify-content-between align-items-center`}>
                        {o?.sTitle}
                        {(render?.selectedOption || isExpired) && <span>{p}%</span>}
                      </div>
                      <div
                        style={{ width: render?.selectedOption || isExpired ? p + '%' : 0 }}
                        className={`${pollStyle.result} ${render?.selectedOption || isExpired ? pollStyle?.[isActive(o?._id)] : ''}
                        position-absolute bottom-0 start-0 h-100 c-transition`}
                      />
                    </div>
                  )
                })}
                {/* <div className={`${styles.item} ${pollStyle.active} p-2 position-relative overflow-hidden br-sm mb-2 flex-grow-1 mx-1`}>
                <div className={`${styles.option} py-1 position-relative`}>
                  Prasidh Krishna
                </div>
                <div style={{ width: '50%' }} className={`${pollStyle.result} position-absolute bottom-0 start-0 h-100 c-transition`}></div>
              </div> */}
              </div>
            </div>
          </div>
          {isExpired && (
            <div className="d-flex justify-content-between px-3 pt-1 pt-md-2 mb-n1 position-relative">
              <div className="fw-light small-text ">{message}</div>
              <div className="text-capitalize font-semi">
                {t('common:Votes')} {abbreviateNumber(pollData?.nTotalVote || 0)}
              </div>
            </div>
          )}
        </section>
      )}
    </PollStyle>
  )
}
SimplePoll.propTypes = {
  poll: PropTypes.object,
  className: PropTypes.string,
  isMulti: PropTypes.bool
}
export default SimplePoll
